import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/getDeleteSeleccionAlimentacion  `, method: 'POST', body: {list}, token: token})
}
